import type { FaireProductEntity } from "../../entity_types/product";

export const p_rtrzug5p58: FaireProductEntity = {
  token: "p_rtrzug5p58",
  type: "product",
  name: "Single Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/99e713d158f44f27a1aee3b045c5ab6a763cef36dae0adba52cd273402786cd0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/67e14db35302a1295798dfb9941b587d4a777fbeed0d2d3464bb0edfc3cf8b7d.jpeg",
    "https://cdn.faire.com/fastly/9c9346ba00722b32347511128867d1e9bb52190054ae96bfa4b70a61d98f2616.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/1ff18af1f43c05e81a4933bbe019f96451b7bbcd45684e1aea6d744d58baf052.jpeg",
    "https://cdn.faire.com/fastly/6f15dfcdf79697a3cba2ba45a1677cd55172e0508a7b001eb697e24a9c8307a9.jpeg",
    "https://cdn.faire.com/fastly/b2eb9ea47d533e04a5496c9c6041f68cf3b10bc56c874b64caeb58ed233937ab.jpeg",
    "https://cdn.faire.com/fastly/9e86eed8cd5f65a19081cb47387c2bbb00b3334f675605dda54017f5405aff87.jpeg",
    "https://cdn.faire.com/fastly/1fc28b8910a71ce47e9f61896455bcc3b92d946642e91cc16ef99309ab399115.jpeg"
  ],
  priceDollars: 3.38,
  description: "Limited Availability - Will Not Restock\n\nThese are essentially a green wristband at the key party... but folks will only know whats up if they're lookin' you up AND down ⬇️🧦 👀\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:09.011Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
